import React, { useRef, useState } from "react";
import MasterTable from "./MasterTable";
import MachineGraphView from "./MachineGraphView";
import MachineCountInBlock from "./MachineCountInBlock";
import YardWiseSummery from "./YardWiseSummery";

const CustomizeTableMaster = ({ data }) => {
  return (
    <div>
      <div className="papaDiv">
        <MasterTable data={data} />
      </div>
      <div className="papaDiv">
        <div className="row">
          <div className="row">
            <h5 className="bg-dark text-white p-1 m-0"> Block type Summary</h5>
          </div>
          <div className="col-md-4">
            <MachineCountInBlock data={data} />
          </div>
          <div className="col-md-8 ">
            <MachineGraphView data={data} />
          </div>
        </div>
        <div className="row">
          <YardWiseSummery data={data} />
        </div>
      </div>
    </div>
  );
};
export default CustomizeTableMaster;
